import { Button } from "../../../components/Buttons";
import { useModal } from "../../../contexts/ModalContext";
import CallServiceTable from "../../../components/Tables/CallServiceTable";
import { useDialog } from "../../../contexts/DialogContext";
import { toast } from "react-toastify";
import * as Yup from "yup";
import FormDefault from "../../../components/Forms/FormDefault";
import { requestAuth } from "../../../components/services/RequestService";
import { H3 } from "../../../components/Text";
import { DialogConfirmation } from "../../../components/Modal";

const ManagePresence = () => {
	const { openModal, onClose } = useModal();
	const { openDialog, dialogClose } = useDialog();

	function handleAdd(reload, data) {
		openModal(<FormPrecinto data={data} reload={reload} onClose={onClose} />);
	}

	function deletePrecinto(option, reload) {
		openDialog(
			<DialogConfirmation
				children={<H3>¿Estas seguro que quieres eliminar este precinto?</H3>}
				onClose={dialogClose}
				method="delete"
				url={`/Dropdown/Option/${option.id}`}
				texBtn="Eliminar"
				handleSuccess={async () => {
					try {
						const parsed = JSON.parse(option.data);
						if (parsed.dataSetId) {
							await requestAuth("delete", `/dataSet/procedure/subData/${parsed.dataSetId}`);
						}
					} catch (e) { }
					reload();
				}}
			/>
		);
	}

	return (
		<CallServiceTable
			dataManipulate={(data) => {
				if (data && data.length > 0) {
					return [...data].sort((a, b) => parseInt(b.name) - parseInt(a.name));
				}
				return data;
			}}
			component={({ reload, data }) => {
				return (
					<>
						<Button onClick={() => handleAdd(reload, data)}>
							Agregar nuevo precinto
						</Button>
					</>
				);
			}}
			urlApi="/Dropdown/precintos/options"
			header={[
				{
					name: "name",
					type: "text",
					label: "Número",
				},
				{
					name: "razonSocial",
					label: "Empresa / Razón Social",
					type: "custom",
					builder: (_, __, data) => {
						try {
							const parsed = JSON.parse(data.data);
							return parsed.razonSocial || "-";
						} catch (e) {
							return "-";
						}
					}
				},
				{
					name: "codigoDeInterno",
					label: "Cód. Interno",
					type: "custom",
					builder: (_, __, data) => {
						try {
							const parsed = JSON.parse(data.data);
							return parsed.codigoDeInterno || "-";
						} catch (e) {
							return "-";
						}
					}
				},
				{
					name: "url",
					label: "Documentos",
					type: "custom",
					builder: (_, __, data) => {
						try {
							const parsed = JSON.parse(data.data);
							const urls = parsed.urls || (parsed.url ? [parsed.url] : []);
							return urls.length > 0 ? (
								<div className="flex flex-wrap gap-1">
									{urls.map((u, i) => (
										<a key={i} href={u} target="_blank" rel="noreferrer" className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded text-xs border border-blue-200">
											Doc {i + 1}
										</a>
									))}
								</div>
							) : "-";
						} catch (e) {
							return "-";
						}
					}
				},
				{
					name: "Action",
					type: "action",
					label: "Acciones",
					sticky: true,
					actions: [
						{
							label: "Eliminar",
							icon: "fas fa-trash",
							action: deletePrecinto,
							color: "text-red-500",
						},
					],
				},
			]}
		/>
	);
};

const FormPrecinto = ({ reload, onClose, data }) => {
	return (
		<FormDefault
			tittle="Crear nuevos precintos"
			fields={[
				{
					label: "Cantidad de precintos a registrar",
					name: "cantidad",
					placeholder: "Introduzca la cantidad",
					type: "number",
				},
			]}
			initialValues={{
				cantidad: 1,
			}}
			validationSchema={Yup.object().shape({
				cantidad: Yup.number()
					.required("Este campo es obligatorio")
					.min(1, "Debe ser al menos 1")
					.integer("Debe ser un número entero"),
			})}
			onSubmit={async (values) => {
				try {
					const numbers =
						data && data.length > 0
							? data.map((d) => parseInt(d.name)).filter((n) => !isNaN(n))
							: [];
					const lastNum = numbers.length > 0 ? Math.max(...numbers) : 0;
					const { cantidad } = values;

					const dataJson = JSON.stringify({ procedureId: "", companyId: "" });

					const requests = Array.from({ length: cantidad }).map((_, index) => {
						return requestAuth("post", "/Dropdown/Option", {
							name: String(lastNum + index + 1),
							type: "Simple",
							data: dataJson,
							DropdownListLabel: "precintos",
						});
					});

					await Promise.all(requests);
					toast.success("Se crearon con éxito");
					reload();
					onClose();
				} catch (error) {
					toast.error("Ocurrió un error al crear los precintos");
				}
			}}
			buttonName="Crear"
		/>
	);
};

export default ManagePresence;
